import { useContext } from "react";
import { EcheckContext } from "../contexts/echeckContext";

export function useEcheck() {
    const context = useContext(EcheckContext);
    
    return context;
}